var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconRole = function SvgIconRole(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "26px",
    viewBox: "0 0 36 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.0196172,23.1077258 C17.6408972,23.1077258 17.2692332,23.2618058 17.0015372,23.5296458 C16.7336972,23.7974858 16.5796172,24.1690058 16.5796172,24.5477258 C16.5796172,24.9264458 16.7336972,25.2979658 17.0015372,25.5658058 C17.2693772,25.8336458 17.6408972,25.9877258 18.0196172,25.9877258 C18.3983372,25.9877258 18.7698572,25.8336458 19.0376972,25.5658058 C19.3069772,25.2979658 19.4596172,24.9264458 19.4596172,24.5477258 C19.4596172,24.1690058 19.3069772,23.7974858 19.0376972,23.5296458 C18.7698572,23.2619498 18.3997772,23.1077258 18.0196172,23.1077258 Z",
    id: "icon-role-path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0745469,18.57528 C33.8558203,17.349016 31.8803906,17.338474 30.6477422,18.5421683 C29.9519297,14.6756018 28.3911328,10.6422742 26.3570625,7.52248925 C25.7249531,6.5529822 24.7023281,5.93496832 23.5513125,5.82686012 C22.4075391,5.71953017 21.297375,6.13250636 20.5049531,6.96015676 C19.6683047,7.83393711 18.8249766,8.27698266 17.9984531,8.27698266 C17.1719297,8.27698266 16.3286016,7.83393711 15.4919531,6.96008601 C14.6995312,6.13250636 13.5896484,5.71974243 12.4455937,5.82678936 C11.2945781,5.93489757 10.2719531,6.55291145 9.63984375,7.52234775 C7.60584375,10.6421327 6.04497656,14.6753896 5.34916406,18.5420268 C4.11651562,17.3383325 2.14115625,17.3488037 0.922359375,18.5751385 C-0.307617188,19.8127935 -0.307617188,21.8265919 0.922359375,23.0643884 C3.22811719,25.3845406 5.91679687,27.1815565 8.91358594,28.4054858 C11.8075781,29.5873887 14.8640625,30.1866534 17.9983828,30.1866534 C21.1326328,30.1866534 24.1891875,29.5873887 27.0831797,28.4054858 C30.0799687,27.1815565 32.7686484,25.3845406 35.0744766,23.0643177 C36.3045234,21.8267334 36.3045234,19.812935 35.0745469,18.57528 Z M10.81575,8.29870335 C11.2118906,7.69116069 11.8536328,7.30372578 12.576375,7.23580439 C13.291875,7.16887353 13.9852969,7.42598428 14.4793125,7.94197457 C15.5755547,9.08687445 16.7924531,9.69208231 17.9985234,9.69208231 C19.2045234,9.69208231 20.4214219,9.0869452 21.5177344,7.94197457 C22.01175,7.42598428 22.7051719,7.16844902 23.4206719,7.23580439 C24.1434141,7.30365503 24.7851562,7.69108994 25.1812969,8.29870335 C26.6366953,10.5309822 27.8372812,13.2567524 28.6250625,16.0380624 C22.3038281,20.7664523 13.6930781,20.7663815 7.37191406,16.0380624 C8.15976562,13.2568231 9.36035156,10.5309822 10.81575,8.29870335 Z M34.0801875,22.0638923 C31.9080234,24.2495459 29.3760703,25.942062 26.5544297,27.0944615 C23.8292578,28.2074525 20.9505937,28.771766 17.9985234,28.771766 C15.0464531,28.771766 12.1677891,28.2074525 9.44261719,27.0944615 C6.62097656,25.942062 4.08895312,24.2495459 1.91685937,22.0638923 C1.23517969,21.3778862 1.23517969,20.2617822 1.91685937,19.5757762 C2.59853906,18.8898409 3.70778906,18.8898409 4.38946875,19.5757762 C7.21722656,22.4211871 10.7935312,24.2832943 14.7318047,24.9605979 C15.1145156,25.0264675 15.4778906,24.767588 15.5433516,24.3824171 C15.6088125,23.9972462 15.3515391,23.6316028 14.9687578,23.5658039 C11.8575,23.0307108 8.99029687,21.6971168 6.58835156,19.6817618 C6.69185156,18.9637054 6.82903125,18.2363098 6.99567187,17.5074992 C10.1982656,19.7498955 14.0646797,20.9752398 17.9985234,20.9752398 C21.9323672,20.9752398 25.7987812,19.7498955 29.001375,17.5074992 C29.1680859,18.2363098 29.3052656,18.9637054 29.4086953,19.6817618 C27.0086484,21.6954895 24.1439766,23.0285882 21.0355312,23.5645304 C20.6528203,23.6305415 20.3956875,23.9962557 20.4612891,24.3813558 C20.5268906,24.766456 20.8899141,25.0251232 21.2730469,24.9592536 C25.2080859,24.280818 28.7817187,22.419206 31.6075078,19.5757762 C32.2891875,18.8898409 33.3984375,18.8898409 34.0801172,19.5757762 C34.7618672,20.2617822 34.7618672,21.377957 34.0801875,22.0638923 Z",
    id: "icon-role-path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-role-06.1---Usuarios---Lista-de-usuarios",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-role-03.1.1---List-users",
    transform: "translate(-229.000000, -281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-role-Info",
    transform: "translate(95.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-role-Icon-/-Role",
    transform: "translate(134.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon-role-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-role-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon-role-Mask",
    fill: "#FF9800",
    fillRule: "nonzero",
    xlinkHref: "#icon-role-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-role-Group",
    mask: "url(#icon-role-mask-2)",
    className: "main-color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-role-Color-/-Primary"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "icon-role-Color",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "icon-role-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-role-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon-role-Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#icon-role-path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-role-Group",
    mask: "url(#icon-role-mask-4)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-role-Hat-color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "icon-role-Color",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRole, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_role.d1ee6e9c.svg";
export { ForwardRef as ReactComponent };